/* eslint-disable no-nested-ternary */
import { FunctionComponent } from 'react';
import BankAccountsContainer from '../Accounts/MyBankAccounts/BankAccountsContainer';

type FC = FunctionComponent;

const AccountAndBilling: FC = () => (
  <>
    <BankAccountsContainer AccountListingType="Billing" />
  </>
);

export default AccountAndBilling;
